/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import { Divider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import 'typeface-roboto';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from 'axios';
import ls from 'local-storage';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import VisibilitySensor from 'react-visibility-sensor';
import LinearProgress from '@material-ui/core/LinearProgress';

let isDlgProvinceMounted = false;
let isDlgCityMounted = false;
let isDlgSubdistrictMounted = false;

const useStyles = makeStyles({
  cardWrapper: {
    marginBottom: 5,
  },
  dialogContentStyle: {
    minHeight: 350,
    maxHeight: 350,
    marginBottom: 30,
    scrollbarWidth: 0,
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: '0px',
      background: 'transparent',
    },
  },
  titleStyle: {
    textAlign: 'center',
  },
  searchPaper: {
    padding: '2px 4px',
    marginTop: '6px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  searchInput: {
    marginLeft: 1,
    flex: 1,
  },
  searchIconButton: {
    padding: 10,
  },
  searchLoading: {
    margin: '2px 10px',
    padding: 2,
  },
  content: {
    display: 'block',
    minHeight: 400,
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },
});

const DialogProvince = (props) => {
  const classes = useStyles();
  const [provinces, setProvinces] = React.useState(ls.get('provinces') || []);
  const [searchText, setSearchText] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [more, setMore] = React.useState(false);

  const {
    onClose, onSelect, open,
  } = props;

  const doLoad = () => {
    if (open) {
      if (isDlgProvinceMounted) {
        setLoading(true);
        const formdata = new FormData();
        formdata.append('last_count', 0);
        axios.post('https://eqiozmart.com/location/province_list/', formdata).then((response) => {
          if (isDlgProvinceMounted) {
            setLoading(false);
            if (_.isArray(response.data.provinces)) {
              setProvinces(response.data.provinces);
              ls.set('provinces', provinces);
              if (_.size(response.data.provinces) > 0) {
                setMore(true);
              } else {
                setMore(false);
              }
            }
          }
        });
      }
    }
  };

  const doLoadMore = () => {
    if (isDlgProvinceMounted) {
      const lastCount = _.size(provinces);
      setLoading(true);
      const formdata = new FormData();
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/location/province_list/', formdata).then((response) => {
        if (isDlgProvinceMounted) {
          setLoading(false);
          if (_.isArray(response.data.provinces)) {
            if (_.size(response.data.provinces) > 0) {
              const provicesNew = _.unionBy(provinces, response.data.provinces, 'province_info_id');
              setProvinces(provicesNew);
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const doSearch = () => {
    if (isDlgProvinceMounted) {
      setLoading(true);
      const formdata = new FormData();
      formdata.append('search', searchText);
      formdata.append('last_count', 0);
      axios.post('https://eqiozmart.com/location/province_search/', formdata).then((response) => {
        if (isDlgProvinceMounted) {
          setLoading(false);
          if (_.isArray(response.data.provinces)) {
            setProvinces(response.data.provinces);
            if (_.size(response.data.provinces) > 0) {
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const doSearchMore = () => {
    if (isDlgProvinceMounted) {
      const lastCount = _.size(provinces);
      setLoading(true);
      const formdata = new FormData();
      formdata.append('search', searchText);
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/location/province_search/', formdata).then((response) => {
        if (isDlgProvinceMounted) {
          setLoading(false);
          if (_.isArray(response.data.provinces)) {
            if (_.size(response.data.provinces) > 0) {
              const provicesNew = _.unionBy(provinces, response.data.provinces, 'province_info_id');
              setProvinces(provicesNew);
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const handleSearchOnChange = (event) => {
    setSearchText(event.target.value);
    doSearch(event.target.value);
  };
  const handleSearchKeyPress = (event) => {
    if (event.target.type !== 'textarea' && event.which === 13 /* Enter */) {
      event.preventDefault();
      setSearchText(event.target.value);
      doSearch(event.target.value);
    }
  };
  const handleSearchClear = () => {
    setSearchText('');
    doLoad();
  };

  const handleClose = () => {
    setSearchText('');
    onClose();
  };

  const handleListItemClick = (selected) => {
    setSearchText('');
    onSelect(selected);
  };

  const handleLoadMore = (isMore) => {
    setMore(false);
    if (isMore) {
      if (_.isEmpty(searchText)) {
        doLoadMore();
      } else {
        doSearchMore();
      }
    }
  };

  useEffect(doLoad, [open]);

  useEffect(() => () => { // component unmount
    isDlgProvinceMounted = false;
  }, []);

  useEffect(() => () => { // component mount
    isDlgProvinceMounted = true;
  });

  return (
    <Dialog maxWidth="xs" fullWidth onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle className={classes.titleStyle} id="simple-dialog-title">PILIH PROVINSI</DialogTitle>
      <Paper component="form" className={classes.searchPaper}>
        <IconButton className={classes.searchIconButton} onClick={handleSearchClear}>
          <SearchIcon />
        </IconButton>
        <InputBase
          autoFocus
          className={classes.searchInput}
          placeholder="Cari provinsi..."
          value={searchText}
          onChange={handleSearchOnChange}
          onKeyPress={handleSearchKeyPress}
        />
        <CircularProgress className={classes.searchLoading} style={loading ? {} : { display: 'none' }} />
      </Paper>
      <DialogContent className={classes.dialogContentStyle}>
        <div className={classes.content}>
          <List>
            {provinces.map((province, index) => (
              <ListItem button onClick={() => handleListItemClick(province)} key={index}>
                <ListItemText primary={province.province_info_name} />
              </ListItem>
            ))}
          </List>
        </div>
        <VisibilitySensor onChange={handleLoadMore}>
          <div style={{ height: 5 }}>
            <LinearProgress style={more ? {} : { display: 'none' }} />
          </div>
        </VisibilitySensor>
      </DialogContent>
    </Dialog>
  );
};

const DialogCity = (props) => {
  const classes = useStyles();
  const [citys, setCitys] = React.useState([]);
  const [searchText, setSearchText] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [more, setMore] = React.useState(false);

  const {
    provinceInfoId, onClose, onSelect, open,
  } = props;

  const doLoad = () => {
    if (open) {
      if (isDlgCityMounted) {
        setLoading(true);
        const formdata = new FormData();
        formdata.append('province_info_id', provinceInfoId);
        formdata.append('last_count', 0);
        axios.post('https://eqiozmart.com/location/city_list/', formdata).then((response) => {
          if (isDlgCityMounted) {
            setLoading(false);
            if (_.isArray(response.data.citys)) {
              setCitys(response.data.citys);
              if (_.size(response.data.citys) > 0) {
                setMore(true);
              } else {
                setMore(false);
              }
            }
          }
        });
      }
    }
  };

  const doLoadMore = () => {
    if (isDlgCityMounted) {
      const lastCount = _.size(citys);
      setLoading(true);
      const formdata = new FormData();
      formdata.append('province_info_id', provinceInfoId);
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/location/city_list/', formdata).then((response) => {
        if (isDlgCityMounted) {
          setLoading(false);
          if (_.isArray(response.data.citys)) {
            if (_.size(response.data.citys) > 0) {
              const provicesNew = _.unionBy(citys, response.data.citys, 'city_info_id');
              setCitys(provicesNew);
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const doSearch = () => {
    if (isDlgCityMounted) {
      setLoading(true);
      const formdata = new FormData();
      formdata.append('province_info_id', provinceInfoId);
      formdata.append('search', searchText);
      formdata.append('last_count', 0);
      axios.post('https://eqiozmart.com/location/city_search/', formdata).then((response) => {
        if (isDlgCityMounted) {
          setLoading(false);
          if (_.isArray(response.data.citys)) {
            setCitys(response.data.citys);
            if (_.size(response.data.citys) > 0) {
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const doSearchMore = () => {
    if (isDlgCityMounted) {
      const lastCount = _.size(citys);
      setLoading(true);
      const formdata = new FormData();
      formdata.append('province_info_id', provinceInfoId);
      formdata.append('search', searchText);
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/location/city_search/', formdata).then((response) => {
        if (isDlgCityMounted) {
          setLoading(false);
          if (_.isArray(response.data.citys)) {
            if (_.size(response.data.citys) > 0) {
              const provicesNew = _.unionBy(citys, response.data.citys, 'city_info_id');
              setCitys(provicesNew);
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const handleSearchOnChange = (event) => {
    setSearchText(event.target.value);
    doSearch(event.target.value);
  };
  const handleSearchKeyPress = (event) => {
    if (event.target.type !== 'textarea' && event.which === 13 /* Enter */) {
      event.preventDefault();
      setSearchText(event.target.value);
      doSearch(event.target.value);
    }
  };
  const handleSearchClear = () => {
    setSearchText('');
    doLoad();
  };

  const handleClose = () => {
    setSearchText('');
    onClose();
  };

  const handleListItemClick = (selected) => {
    setSearchText('');
    onSelect(selected);
  };

  const handleLoadMore = (isMore) => {
    setMore(false);
    if (isMore) {
      if (_.isEmpty(searchText)) {
        doLoadMore();
      } else {
        doSearchMore();
      }
    }
  };

  useEffect(doLoad, [open]);

  useEffect(() => () => { // component unmount
    isDlgCityMounted = false;
  }, []);

  useEffect(() => () => { // component mount
    isDlgCityMounted = true;
  });

  return (
    <Dialog maxWidth="xs" fullWidth onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle className={classes.titleStyle} id="simple-dialog-title">PILIH KAB/KOTA</DialogTitle>
      <Paper component="form" className={classes.searchPaper}>
        <IconButton className={classes.searchIconButton} onClick={handleSearchClear}>
          <SearchIcon />
        </IconButton>
        <InputBase
          autoFocus
          className={classes.searchInput}
          placeholder="Cari kab/kota..."
          value={searchText}
          onChange={handleSearchOnChange}
          onKeyPress={handleSearchKeyPress}
        />
        <CircularProgress className={classes.searchLoading} style={loading ? {} : { display: 'none' }} />
      </Paper>
      <DialogContent className={classes.dialogContentStyle}>
        <div className={classes.content}>
          <List>
            {citys.map((city, index) => (
              <ListItem button onClick={() => handleListItemClick(city)} key={index}>
                <ListItemText primary={city.city_info_name} />
              </ListItem>
            ))}
          </List>
        </div>
        <VisibilitySensor onChange={handleLoadMore}>
          <div style={{ height: 5 }}>
            <LinearProgress style={more ? {} : { display: 'none' }} />
          </div>
        </VisibilitySensor>
      </DialogContent>
    </Dialog>
  );
};

const DialogSubdistrict = (props) => {
  const classes = useStyles();
  const [subdistricts, setSubdistricts] = React.useState([]);
  const [searchText, setSearchText] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [more, setMore] = React.useState(false);

  const {
    cityInfoId, onClose, onSelect, open,
  } = props;

  const doLoad = () => {
    if (open) {
      if (isDlgSubdistrictMounted) {
        setLoading(true);
        const formdata = new FormData();
        formdata.append('city_info_id', cityInfoId);
        formdata.append('last_count', 0);
        axios.post('https://eqiozmart.com/location/subdistrict_list/', formdata).then((response) => {
          if (isDlgSubdistrictMounted) {
            setLoading(false);
            if (_.isArray(response.data.subdistricts)) {
              setSubdistricts(response.data.subdistricts);
              if (_.size(response.data.subdistricts) > 0) {
                setMore(true);
              } else {
                setMore(false);
              }
            }
          }
        });
      }
    }
  };

  const doLoadMore = () => {
    if (isDlgSubdistrictMounted) {
      const lastCount = _.size(subdistricts);
      setLoading(true);
      const formdata = new FormData();
      formdata.append('city_info_id', cityInfoId);
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/location/subdistrict_list/', formdata).then((response) => {
        if (isDlgSubdistrictMounted) {
          setLoading(false);
          if (_.isArray(response.data.subdistricts)) {
            if (_.size(response.data.subdistricts) > 0) {
              const provicesNew = _.unionBy(subdistricts, response.data.subdistricts, 'subdistrict_info_id');
              setSubdistricts(provicesNew);
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const doSearch = () => {
    if (isDlgSubdistrictMounted) {
      setLoading(true);
      const formdata = new FormData();
      formdata.append('city_info_id', cityInfoId);
      formdata.append('search', searchText);
      formdata.append('last_count', 0);
      axios.post('https://eqiozmart.com/location/subdistrict_search/', formdata).then((response) => {
        if (isDlgSubdistrictMounted) {
          setLoading(false);
          if (_.isArray(response.data.subdistricts)) {
            setSubdistricts(response.data.subdistricts);
            if (_.size(response.data.subdistricts) > 0) {
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const doSearchMore = () => {
    if (isDlgSubdistrictMounted) {
      const lastCount = _.size(subdistricts);
      setLoading(true);
      const formdata = new FormData();
      formdata.append('city_info_id', cityInfoId);
      formdata.append('search', searchText);
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/location/subdistrict_search/', formdata).then((response) => {
        if (isDlgSubdistrictMounted) {
          setLoading(false);
          if (_.isArray(response.data.subdistricts)) {
            if (_.size(response.data.subdistricts) > 0) {
              const provicesNew = _.unionBy(subdistricts, response.data.subdistricts, 'subdistrict_info_id');
              setSubdistricts(provicesNew);
              setMore(true);
            } else {
              setMore(false);
            }
          }
        }
      });
    }
  };

  const handleSearchOnChange = (event) => {
    setSearchText(event.target.value);
    doSearch(event.target.value);
  };
  const handleSearchKeyPress = (event) => {
    if (event.target.type !== 'textarea' && event.which === 13 /* Enter */) {
      event.preventDefault();
      setSearchText(event.target.value);
      doSearch(event.target.value);
    }
  };
  const handleSearchClear = () => {
    setSearchText('');
    doLoad();
  };

  const handleClose = () => {
    setSearchText('');
    onClose();
  };

  const handleListItemClick = (selected) => {
    setSearchText('');
    onSelect(selected);
  };

  const handleLoadMore = (isMore) => {
    setMore(false);
    if (isMore) {
      if (_.isEmpty(searchText)) {
        doLoadMore();
      } else {
        doSearchMore();
      }
    }
  };

  useEffect(doLoad, [open]);

  useEffect(() => () => { // component unmount
    isDlgSubdistrictMounted = false;
  }, []);

  useEffect(() => () => { // component mount
    isDlgSubdistrictMounted = true;
  });

  return (
    <Dialog maxWidth="xs" fullWidth onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle className={classes.titleStyle} id="simple-dialog-title">PILIH KECAMATAN</DialogTitle>
      <Paper component="form" className={classes.searchPaper}>
        <IconButton className={classes.searchIconButton} onClick={handleSearchClear}>
          <SearchIcon />
        </IconButton>
        <InputBase
          autoFocus
          className={classes.searchInput}
          placeholder="Cari kecamatan..."
          value={searchText}
          onChange={handleSearchOnChange}
          onKeyPress={handleSearchKeyPress}
        />
        <CircularProgress className={classes.searchLoading} style={loading ? {} : { display: 'none' }} />
      </Paper>
      <DialogContent className={classes.dialogContentStyle}>
        <div className={classes.content}>
          <List>
            {subdistricts.map((subdistrict, index) => (
              <ListItem button onClick={() => handleListItemClick(subdistrict)} key={index}>
                <ListItemText primary={subdistrict.subdistrict_info_name} />
              </ListItem>
            ))}
          </List>
        </div>
        <VisibilitySensor onChange={handleLoadMore}>
          <div style={{ height: 5 }}>
            <LinearProgress style={more ? {} : { display: 'none' }} />
          </div>
        </VisibilitySensor>
      </DialogContent>
    </Dialog>
  );
};

const UsrLokasiPengiriman = (props) => {
  const classes = useStyles();
  const { data, onChange } = props;
  const [openProvince, setOpenProvince] = React.useState(false);
  const [openCity, setOpenCity] = React.useState(false);
  const [openSubdistrict, setOpenSubdistrict] = React.useState(false);
  const [provinceInfoId, setProvinceInfoId] = React.useState('');
  const [cityInfoId, setCityInfoId] = React.useState('');

  useEffect(() => {
    setProvinceInfoId(data.usr_province_id);
    setCityInfoId(data.usr_city_id);
  }, [data]);

  const handleClickOpen = () => {
    setOpenProvince(true);
  };

  const handleOnProvinceSelect = (province) => {
    setOpenProvince(false);
    setProvinceInfoId(province.province_info_id);
    data.usr_province_id = province.province_info_id;
    data.usr_province_name = province.province_info_name;
    data.usr_city_id = '';
    data.usr_city_name = '';
    data.usr_city_type = '';
    data.usr_subdistrict_id = '';
    data.usr_subdistrict_name = '';
    onChange(data);
    setOpenCity(true);
  };
  const handleOnProvinceClose = () => {
    setOpenProvince(false);
  };

  const handleOnCitySelect = (city) => {
    setOpenCity(false);
    setCityInfoId(city.city_info_id);
    data.usr_city_id = city.city_info_id;
    data.usr_city_name = city.city_info_name;
    data.usr_city_type = city.city_type;
    data.usr_subdistrict_id = '';
    data.usr_subdistrict_name = '';
    onChange(data);
    setOpenSubdistrict(true);
  };
  const handleOnCityClose = () => {
    setOpenCity(false);
  };

  const handleOnSubdistrictSelect = (subdistrict) => {
    setOpenSubdistrict(false);
    data.usr_subdistrict_id = subdistrict.subdistrict_info_id;
    data.usr_subdistrict_name = subdistrict.subdistrict_info_name;
    onChange(data);
  };
  const handleOnSubdistrictClose = () => {
    setOpenSubdistrict(false);
  };

  return (
    <Card className={classes.cardWrapper}>
      <CardHeader
        title="Lokasi Pengiriman"
        subheader="Digunakan untuk menghitung ongkos kirim"
      />
      <CardActionArea onClick={handleClickOpen}>
        <CardContent>
          <Grid container spacing={2} justify="space-between">
            <Grid item>
              <Typography variant="button">Provinsi</Typography>
            </Grid>
            <Grid item>
              <Typography variant="button">{data.usr_province_name}</Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid container spacing={2} justify="space-between">
            <Grid item>
              <Typography variant="button">Kab / Kota</Typography>
            </Grid>
            <Grid item>
              <Typography variant="button">{data.usr_city_name}</Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid container spacing={2} justify="space-between">
            <Grid item>
              <Typography variant="button">Kecamatan</Typography>
            </Grid>
            <Grid item>
              <Typography variant="button">{data.usr_subdistrict_name}</Typography>
            </Grid>
          </Grid>
          <Divider />
        </CardContent>
      </CardActionArea>
      <DialogProvince open={openProvince} onSelect={handleOnProvinceSelect} onClose={handleOnProvinceClose} />
      <DialogCity open={openCity} provinceInfoId={provinceInfoId} onSelect={handleOnCitySelect} onClose={handleOnCityClose} />
      <DialogSubdistrict open={openSubdistrict} cityInfoId={cityInfoId} onSelect={handleOnSubdistrictSelect} onClose={handleOnSubdistrictClose} />
    </Card>
  );
};

export default UsrLokasiPengiriman;
